import axios from "axios";

const API_URL = process.env.REACT_APP_API_URL;

class ParcelService {
  index(distance='long') {
    return axios.get(API_URL + `parcels?distance=${distance}`, {}).then(response => {
        return response.data;
    });
  }
}

export default new ParcelService();